export const financialYear = (currentYear: number) => {
    const currentMonth = new Date().getMonth();
    if (currentMonth > 2) {
        return `FY ${currentYear}-${currentYear + 1}`;
    } else {
        return `FY ${currentYear - 1}-${currentYear}`;
    }
};
